export const core_backend_url = process.env.REACT_APP_BACKEND_URL;

// const lang = langArray[0]
export const appConfig = {
	appEnv: `${process.env.REACT_APP_NODE_ENV ?? 'development'}`,
}

export const crypto_secret_key = `${process.env.REACT_APP_CRYPTO_SECRET_KEY}`



